// @flow

import * as React from 'react';

import { useDispatch } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import { useTranslator } from '@gandi/translate';

import { Intro } from 'src/Layout/components/Intro';

import { fetchTrialAndRedirectToConvert } from 'src/Studio/modules/instances';
import { useAppSelector } from 'src/hooks/useAppSelector';
import { selectIsEligibleStudioUser } from 'src/modules/gandi-studio';

import { CallToAction } from './CallToAction';

import styles from './EmptyCart.scss';

export function EmptyCart(): React.MixedElement {
  const { __ } = useTranslator();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isStudioUser = useAppSelector(selectIsEligibleStudioUser);

  React.useEffect(() => {
    if (isStudioUser) {
      dispatch(fetchTrialAndRedirectToConvert(navigate));
    }
  }, [dispatch, isStudioUser, navigate]);

  return (
    <div className={styles.root}>
      <Intro title={__('Your shopping cart is empty.')} />
      <CallToAction isEmptyPage />
    </div>
  );
}
